import permissions from '../../permissions'
const CHURN_REASON_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.CHURN_REASONS.CREATE,
    description: 'Essa permissão dá acesso à listagem e à criação.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.CHURN_REASONS.UPDATE,
    description: 'Essa permissão dá acesso à listagem e à edição.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.CHURN_REASONS.LIST,
    description:
      'Essa permissão dá acesso somente à listagem. Caso outras permissões já concedam esse acesso, esta permissão não é necessária.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.CHURN_REASONS.DESTROY,
    description: 'Essa permissão dá acesso à listagem e à exclusão.',
  },
]

export default CHURN_REASON_LIST
